<template>
  <portlet :variant="bgColor">
    <form>
      <form-row>
        <div class="col">
          <h3 class="form_section_title">
            職缺管理
          </h3>
        </div>
      </form-row>
      <form-row>
        <form-group
          class="col-sm-4 col-12"
          label="* 標題"
        >
          <input-group>
            <form-input
              v-model="job.job_title"
              name="job-title"
            />
          </input-group>
        </form-group>
        <form-group
          class="col-sm-4 col-12"
          label="截止日期"
        >
          <date-time-picker
            v-model="job.job_publishing_deadline"
            input-name="job-expiry-date"
            :min-datetime="$moment().toISOString(true)"
            format="yyyy/LL/dd"
          >
            <span
              slot="before"
              aria-hidden="true"
              class="input-group-text text-muted btn-pill"
            >
              <font-awesome-icon icon="calendar-alt" />
            </span>
          </date-time-picker>
        </form-group>
        <form-group
          class="col-sm-4 col-12"
          label="* 產業類別"
        >
          <input-group>
            <form-select
              :default-value="job.job_industry"
              :options="categoriesGetter"
              select-name="category_name"
              select-value="category_value"
              name="industries"
              @change="industrySelected"
            />
          </input-group>
        </form-group>
      </form-row>
      <form-row>
        <form-group
          class="col-sm-4 col-6"
          label="* 工作年資"
        >
          <input-group>
            <form-select
              :default-value="job.job_years_experience"
              :options="yearsExperience"
              name="year-experience"
              @change="yearsOfExperienceSelected"
            />
          </input-group>
        </form-group>
        <form-group
          class="col-sm-4 col-6"
          label="* 工作地區"
        >
          <input-group>
            <form-select
              :default-value="job.job_region"
              :options="regionsGetter"
              select-name="name"
              select-value="id"
              name="job-region"
              @change="regionSelected"
            />
          </input-group>
        </form-group>
        <form-group
          class="col-sm-4 col-12"
          label="* 工作地點"
        >
          <input-group>
            <form-input
              v-model="job.job_subregion"
              name="job-subregion"
            />
          </input-group>
        </form-group>
      </form-row>
      <form-row>
        <form-group
          class="col-sm-4 col-12"
          label="* 職務類型"
        >
          <input-group>
            <form-select
              :default-value="job.job_identity"
              :options="identitiesGetter"
              select-name="identity_name"
              select-value="identity_value"
              name="identities"
              @change="identitySelected"
            />
          </input-group>
        </form-group>
        <form-group
          class="col-sm-8 col-12"
          label="* 職務內容"
        >
          <input-group>
            <form-textarea
              v-model="job.job_content"
              name="job-responsibilities"
            />
          </input-group>
        </form-group>
      </form-row>
      <form-row>
        <form-group
          cols="12"
          label="* 科系需求"
        >
          <input-group>
            <multi-select
              v-model="job.job_departments"
              :options="departmentsGetter"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              :multiple="true"
              :taggable="true"
              label="department_name"
              track-by="department_value"
              placeholder="請選擇..."
              select-label="點一下選取"
              deselect-label="點一下取消選取"
              selected-label="已選取"
            />
          </input-group>
        </form-group>
        <form-group
          cols="12"
          label="其他條件"
        >
          <input-group>
            <form-textarea
              v-model="job.job_miscellaneous"
              name="job-qualifications"
            />
          </input-group>
        </form-group>
      </form-row>
      <form-row>
        <form-group
          class="col-sm-4 col-12"
          label="* 聯絡人"
        >
          <input-group>
            <form-input
              v-model="job.job_contact_person"
              name="contact-person"
            />
          </input-group>
        </form-group>
        <form-group
          class="col-sm-4 col-12"
          label="* 聯絡電話"
        >
          <input-group>
            <form-input
              v-model="job.job_tel"
              name="contact-email"
            />
          </input-group>
        </form-group>
        <form-group
          class="col-sm-4 col-12"
          label="* 電子信箱"
        >
          <input-group>
            <form-input
              v-model="job.job_email"
              name="contact-email"
            />
          </input-group>
        </form-group>
      </form-row>

      <form-section-divider />
      <form-row>
        <div class="col">
          <h3 class="form_section_title">
            附件
          </h3>
        </div>
      </form-row>
      <form-row>
        <form-group
          class="col-sm-6 col-12"
        >
          <input-group>
            <input-file
              name="job-attachments"
              @change="uploadFiles"
            />
          </input-group>
          <small
            id="passwordHelpBlock"
            slot="help-text"
            class="form-text text-muted"
          >
            附件檔案格式(png/jpg/pdf/excel/word/otd)
          </small>
        </form-group>
        <div class="col-6">
          <bootstrap-list-group
            :list="filesPreview"
            item-title="name"
            item-badge="size"
          >
            <template v-slot:badges="{item}">
              <span
                v-if="item.new"
                class="badge badge-danger badge-pill text-right"
              >
                new
              </span>
            </template>
            <template v-slot:title="{index}">
              <font-awesome-icon
                icon="times-circle"
                :style="{ color: 'gray' }"
                @click="removeFile(index, $event)"
              />
            </template>
          </bootstrap-list-group>
        </div>
      </form-row>
      <form-section-divider />
      <form-row class="justify-content-end">
        <div class="col-sm-2 col-5 d-inline-flex justify-content-end">
          <button-wrapper
            size="fill"
            @click.prevent="submitData"
          >
            確定
          </button-wrapper>
        </div>
      </form-row>
    </form>
  </portlet>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import MultiSelect from 'vue-multiselect'
import Portlet from '~components/common/Portlet'
import FormRow from '~components/common/form/Row'
import FormGroup from '~components/common/form/Group'
import FormInput from '~components/common/form/input'
import InputGroup from '~components/common/form/input/Group'
import ButtonWrapper from '~components/common/buttons'
import FormSelect from '~components/common/form/Select'
import FormSectionDivider from '~components/common/form/section/Divider'
import CheckInput from '~components/common/form/input/Check'
import FormTextarea from '~components/common/form/input/Textarea'
import InputFile from '~components/common/form/input/File'
import BootstrapListGroup from '~bootstrap/ListGroup'
import DateTimePicker from '~lar/DateTimePicker'
import { formatBytes } from '~utils/file'
export default {
  name: 'EnterpriseJobOpeningForm',
  components: {
    MultiSelect,
    Portlet,
    FormRow,
    FormGroup,
    FormInput,
    InputFile,
    InputGroup,
    ButtonWrapper,
    FormSelect,
    FormSectionDivider,
    CheckInput,
    FormTextarea,
    DateTimePicker,
    BootstrapListGroup
  },
  props: {
    bgColor: {
      type: String,
      default: ''
    },
    currentJob: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      now: this.$moment().toDate(),
      job: {
        job_attachments: [],
        job_new_attachments: [],
        job_opening_status: false
      },
      filesPreview: [],
      yearsExperience: [{ name: '0-1', value: 1 }, { name: '1-3', value: 2 }, { name: '3-5', value: 3 }, { name: '5年以上', value: 4 }]
    }
  },
  computed: {
    ...mapGetters('pages/jobs', [
      'categoriesGetter',
      'identitiesGetter',
      'departmentsGetter',
      'regionsGetter'
    ])
  },
  watch: {
    currentJob (value) {
      this.job = Object.assign({}, this.job, value)
      if (value.job_attachments.length) {
        value.job_attachments.map((file) => {
          this.filesPreview.push({
            name: file.attachment_file_name.length > 25 ? `${file.attachment_file_name.slice(0, 23)}...` : file.attachment_file_name,
            size: formatBytes(file.attachment_size, 0),
            type: file.attachment_type,
            new: false
          })
        })
      }
    }
  },
  async created () {
    await this.getCategories()
    await this.getIdentities()
    await this.getDepartments()
    await this.getRegions()
  },
  methods: {
    ...mapActions('pages/jobs', [
      'getCategories',
      'getIdentities',
      'getDepartments',
      'getRegions',
      'getSubregions'
    ]),
    submitData () {
      this.$emit('submit', this.job)
    },
    uploadFiles (files) {
      files.map((file) => {
        this.filesPreview.push({
          name: file.name.length > 30 ? `${file.name.slice(0, 28)}...` : file.name,
          size: formatBytes(file.size, 0),
          type: file.type,
          new: true
        })
        this.job.job_new_attachments.push(file)
      })
    },
    removeFile (index) {
      if (this.filesPreview[index].new) {
        this.job.job_new_attachments.splice(index - (this.job.job_attachments.length - 1) - 1, 1)
      } else {
        this.job.job_attachments.splice(index, 1)
      }
      this.filesPreview.splice(index, 1)
    },
    industrySelected (industry) {
      this.job = Object.assign({}, this.job, {
        job_industry: industry.category_value
      })
    },
    expiryDateSelected (dates) {
      this.job = Object.assign({}, this.job, {
        job_publishing_deadline: this.$moment(dates.startDate).format('YYYY/MM/DD HH:mm:ss')
      })
    },
    yearsOfExperienceSelected (years) {
      this.job = Object.assign({}, this.job, {
        job_years_experience: years.value
      })
    },
    regionSelected (region) {
      this.job = Object.assign({}, this.job, {
        job_region: region.id
      })
    },
    identitySelected (identity) {
      this.job = Object.assign({}, this.job, {
        job_identity: identity.identity_value
      })
    },
    isJobOpen (isOpen) {
      if (!isOpen) {
        this.job = Object.assign({}, this.job, {
          job_publishing_deadline: this.now
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>

.dateTimePickerWrapper{
  .lar_input_group {
    .form-control[readonly]{
      background-color: #fff!important;
    }
  }
}

</style>
